export default "__VITE_ASSET__BjjK9F6s__"